import { render, staticRenderFns } from "./LeadsPause.vue?vue&type=template&id=44f91cd8&scoped=true"
import script from "./LeadsPause.vue?vue&type=script&lang=js"
export * from "./LeadsPause.vue?vue&type=script&lang=js"
import style0 from "./LeadsPause.vue?vue&type=style&index=0&id=44f91cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f91cd8",
  null
  
)

export default component.exports